namespace GeniuzPOS.Common {
    export interface CountByStatusRequest extends Serenity.ServiceRequest {
    }
}
